import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { makeStyles } from 'tss-react/mui';
import { useStylesModalOffer } from './hooks/useStyles';
import { getNameQuantity, thousands } from '../../../../../utils/utils';
import { IProduct, PriceValue } from '../../../../../interfaces/product';
import ProductCount from '../ProductCount';
import TopTableCell from '../../../../../components/other/Table/TopTableCell';

const useStyles = makeStyles()(theme => {
  return {
    headerRow: {
      color: '#6a96c3 !important',
      backgroundColor: '#fff !important',
      fontSize: '17px !important',
      fontWeight: theme.typography.fontWeightBold,
      borderBottom: '0 !important',

      '& p': {
        fontSize: '18px !important',
      },
    },
    bodyRow: {
      position: 'relative',
      borderBottom: '0 !important',
      marginBottom: '10px !important',
      backgroundColor: '#F5F6F7 !important',
    },
  };
});

export function OffersForBuyerTable({
  prices,
  product,
}: {
  prices: PriceValue[];
  product: IProduct;
}) {
  const { classes } = useStylesModalOffer();
  const { classes: styles } = useStyles();
  const intl = useIntl();

  return (
    <div className={classes.containerOffersTable}>
      <Table aria-label='CompaniesTable'>
        <TableHead style={{ backgroundColor: '#ffffff' }}>
          <TableRow>
            <TopTableCell
              className={styles.headerRow}
              style={{
                display: 'flex',
                gap: 8,
                justifyContent: 'space-between',
                marginRight: 40,
              }}
            >
              <Typography component='p' className={styles.headerRow}>
                {intl.formatMessage({ id: 'SUPPLY.HEADER.LIST' })}
              </Typography>
              <Typography component='p' className={styles.headerRow}>
                {intl.formatMessage({ id: 'SUPPLY.HEADER.PRICE' })}
              </Typography>
            </TopTableCell>
            {/* <TopTableCell className={styles.headerRow}>
              {intl.formatMessage({ id: 'SUPPLY.HEADER.PRICE' })}
            </TopTableCell> */}
            <TopTableCell className={styles.headerRow}>
              {intl.formatMessage({ id: 'DELIVERY.ON.ORDER' })}
            </TopTableCell>
            <TopTableCell className={styles.headerRow}>
              {intl.formatMessage({ id: 'SUBMENU.SHIPPING' })}
            </TopTableCell>
            <TopTableCell className={styles.headerRow}>
              {intl.formatMessage({ id: 'STOCK' })}
            </TopTableCell>
            <TopTableCell className={styles.headerRow}>
              {intl.formatMessage({ id: 'SUBMENU.SHIPPING' })}
            </TopTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {prices.map((i, index) => {
            const quantityLevel = getNameQuantity(i?.vendor?.quantity_level);
            const secondQantityLevel = getNameQuantity(i?.vendor?.second_quantity_level);
            return (
              <>
                <TableRow key={index}>
                  <TableCell
                    className={styles.bodyRow}
                    style={{
                      borderRadius: '4px 0 0 4px',
                      position: 'relative',
                    }}
                  >
                    <div className={classes.containerPrices}>
                      {i.prices?.map(item => (
                        <div
                          style={{ display: 'flex', gap: 8, justifyContent: 'space-between' }}
                          key={item?.amount}
                        >
                          <Typography
                            component='p'
                            className={classes.price}
                            style={{ minWidth: 130 }}
                          >
                            {`от ${item?.amount} шт.`}
                          </Typography>
                          <div className={classes.onceColumn}>
                            <Typography
                              component='p'
                              className={classes.price}
                              style={{ fontWeight: 'bold' }}
                            >
                              {thousands(String(item.price || '0'))}
                            </Typography>
                            <Typography component='p' className={classes.rub}>
                              ₽
                            </Typography>
                          </div>
                        </div>
                      ))}
                      <div
                        style={{
                          borderRight: '1px solid #e6e7e8',
                          height: 'calc(100% - 30px)',
                          width: 1,
                          position: 'absolute',
                          top: 15,
                          right: 10,
                        }}
                      />
                    </div>
                  </TableCell>

                  <TableCell className={styles.bodyRow}>
                    <Typography component='p' className={classes.countTitle}>
                      {i.vendor?.order_quantity
                        ? `${thousands(String(i.vendor?.order_quantity))}`
                        : secondQantityLevel || 0}
                    </Typography>
                  </TableCell>
                  <TableCell
                    className={styles.bodyRow}
                    style={{
                      position: 'relative',
                      paddingRight: 15,
                    }}
                  >
                    <div>
                      <Typography className={classes.period} component='p'>
                        {` ${thousands(String(i.vendor?.delivery_period || '0'))} дн.`}
                      </Typography>
                      <div
                        style={{
                          borderRight: '1px solid #e6e7e8',
                          height: 'calc(100% - 30px)',
                          width: 1,
                          position: 'absolute',
                          top: 15,
                          right: 15,
                        }}
                      />
                    </div>
                  </TableCell>
                  <TableCell className={styles.bodyRow}>
                    <Typography component='p' className={classes.countTitle}>
                      {i.vendor?.stock_quantity
                        ? `${thousands(String(i.vendor?.stock_quantity || '0'))}`
                        : quantityLevel || 0}
                    </Typography>
                  </TableCell>
                  <TableCell className={styles.bodyRow} style={{ position: 'relative' }}>
                    <Typography className={classes.period} component='p'>
                      1 дн.
                    </Typography>
                    <div
                      style={{
                        borderRight: '1px solid #e6e7e8',
                        height: 'calc(100% - 30px)',
                        width: 1,
                        position: 'absolute',
                        top: 15,
                        right: 15,
                      }}
                    />
                  </TableCell>

                  <TableCell
                    className={styles.bodyRow}
                    style={{
                      borderTopRightRadius: 4,
                      borderBottomRightRadius: 4,
                      overflow: 'hidden',
                      width: 300,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        // justifyContent: 'center',
                        marginTop: 25,
                        minHeight: 150,
                      }}
                    >
                      <p
                        className={classes.store}
                        style={{ fontWeight: 'normal', fontSize: 14 }}
                      >
                        {i.vendor?.code ? `Склад ${i.vendor.code}` : `Склад №${index + 1}`}
                      </p>
                      <ProductCount
                        priceBold
                        showPrice
                        product={product}
                        priceValue={i}
                        style={{ justifyContent: 'flex-end' }}
                      />
                    </div>
                    {/* <div style={{ paddingRight: 25 }}>
                    <p
                      className={classes.price}
                      style={{
                        maxWidth: 100,
                      }}
                    >
                      {`Склад ${index + 1}`}
                    </p>
                    <ProductCount showPrice product={product} priceValue={i} />
                    <div />
                  </div> */}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <div style={{ height: 20 }} />
                </TableRow>
              </>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
